import { DateTime } from 'luxon';
import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type LogisticsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function LogisticsSection({ item }: LogisticsSectionProps) {
  return (
    <Section
      icon="truck/truck-default"
      title="Logistics"
      color="neutral"
      className="flex-shrink-0"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="logistics-details-readonly-section"
    >
      <Stack direction="row" className="gap-0.5">
        <Stack direction="col" className="gap-3 min-w-0">
          <ReadOnlyField
            label="Incoterm"
            value={item?.draft_purchase_order?.incoterm}
            id="incoterm"
          />
          <ReadOnlyField
            label="Lead Time"
            value={item?.lead_time_in_weeks}
            suffix="weeks"
            id="lead-time"
          />
        </Stack>
        <Stack direction="col" className="gap-3 w-full min-w-0">
          <ReadOnlyField
            label="Country of Origin"
            value={item?.draft_purchase_order?.country_of_origin}
            id="country-of-origin"
          />
          <ReadOnlyField
            label="Reorder Lead Time"
            value={item?.reorder_lead_time_in_weeks}
            suffix="weeks"
            id="reorder-lead-time"
          />
        </Stack>
        <Stack direction="col" className="gap-3 w-full min-w-0">
          <ReadOnlyField
            label="Shipment Mode"
            value={item?.draft_purchase_order?.shipment_mode}
            id="shipment-mode"
          />
          <ReadOnlyField
            label="Cancel Date"
            value={
              item?.draft_purchase_order?.due_date
                ? DateTime.fromJSDate(
                    new Date(item?.draft_purchase_order?.due_date),
                    {
                      zone: 'utc',
                    },
                  ).toFormat('DD')
                : undefined
            }
            id="cancel-date"
          />
        </Stack>
      </Stack>
    </Section>
  );
}

export default LogisticsSection;
